import { render, staticRenderFns } from "./FolderButton.vue?vue&type=template&id=41646af6&"
import script from "./FolderButton.vue?vue&type=script&lang=js&"
export * from "./FolderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports